const CORE_PREFIX = "/api/core";
const TAX_PREFIX = "/api/tax";

export const CORE_AUTH_BASE_URL = `${CORE_PREFIX}/auth`;
export const coreAuthUrls = {
    login: `${CORE_AUTH_BASE_URL}/login`,
    logout: `${CORE_AUTH_BASE_URL}/logout`,
    refreshToken: `${CORE_AUTH_BASE_URL}/refreshToken`,
    resetPassword: `${CORE_AUTH_BASE_URL}/password-reset`,
    resetPasswordConfirm: `${CORE_AUTH_BASE_URL}/password-reset/confirm`,
    resetPasswordVerify: `${CORE_AUTH_BASE_URL}/password-reset/verify`,
};

export const CORE_FEEDBACK_BASE_URL = `${CORE_PREFIX}/user-feedbacks`;
export const coreFeedbackUrls = {
    filter: `${CORE_FEEDBACK_BASE_URL}/filter`,
    resolve: (id: string) => `${CORE_FEEDBACK_BASE_URL}/${id}/resolve`,
    canceled: (id: string) => `${CORE_FEEDBACK_BASE_URL}/${id}/canceled`,
    types: `${CORE_FEEDBACK_BASE_URL}/types`,
    direct: `${CORE_FEEDBACK_BASE_URL}/direct`,
};

export const CORE_ACCOUNT_BASE_URL = `${CORE_PREFIX}/users`;
export const coreAccountUrls = {
    filter: `${CORE_ACCOUNT_BASE_URL}/filter`,
    create: CORE_ACCOUNT_BASE_URL,
    get: (id: string) => `${CORE_ACCOUNT_BASE_URL}/${id}`,
    delete: (id: string) => `${CORE_ACCOUNT_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_ACCOUNT_BASE_URL}/${id}`,
    enable: (id: string) => `${CORE_ACCOUNT_BASE_URL}/${id}/enable`,
    disable: (id: string) => `${CORE_ACCOUNT_BASE_URL}/${id}/disable`,
    simpleInfo: `${CORE_ACCOUNT_BASE_URL}/self`,
    changePassword: (id: string) => `${CORE_ACCOUNT_BASE_URL}/${id}/password`,
    markTemporary: (id: string) => `${CORE_ACCOUNT_BASE_URL}/${id}/activate-temporary-password`,
    unmarkTemporary: (id: string) => `${CORE_ACCOUNT_BASE_URL}/${id}/deactivate-temporary-password`,
};
export const CORE_PAYMENT_ORDER_BASE_URL = `${CORE_PREFIX}/payment-orders`;
export const corePaymentOrderUrls = {
    get: (id: string) => `${CORE_PAYMENT_ORDER_BASE_URL}/${id}`,
    filter: `${CORE_PAYMENT_ORDER_BASE_URL}/filter`,
};

export const CORE_PAYMENT_OFFER_BASE_URL = `${CORE_PREFIX}/payment-offers`;
export const corePaymentOfferUrls = {
    create: CORE_PAYMENT_OFFER_BASE_URL,
    get: (id: string) => `${CORE_PAYMENT_OFFER_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_PAYMENT_OFFER_BASE_URL}/${id}`,
    filter: `${CORE_PAYMENT_OFFER_BASE_URL}/filter`,
    delete: (id: string) => `${CORE_PAYMENT_OFFER_BASE_URL}/${id}`,
};

export const CORE_PAYMENT_COUPON_BASE_URL = `${CORE_PREFIX}/payment-coupons`;
export const corePaymentCouponUrls = {
    create: CORE_PAYMENT_COUPON_BASE_URL,
    get: (id: string) => `${CORE_PAYMENT_COUPON_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_PAYMENT_COUPON_BASE_URL}/${id}`,
    filter: `${CORE_PAYMENT_COUPON_BASE_URL}/filter`,
    delete: (id: string) => `${CORE_PAYMENT_COUPON_BASE_URL}/${id}`,
};

export const CORE_EMAIL_BASE_URL = `${CORE_PREFIX}/emails`;
export const coreEmailUrls = {
    filter: `${CORE_EMAIL_BASE_URL}/filter`,
    get: (id: string) => `${CORE_EMAIL_BASE_URL}/${id}`,
    getAttachments: (emailId: string) => `${CORE_EMAIL_BASE_URL}/${emailId}/attachments`,
};

export const CORE_SCHEDULER_BASE_URL = `${CORE_PREFIX}/scheduler-jobs`;
export const coreSchedulerUrls = {
    filter: `${CORE_SCHEDULER_BASE_URL}/filter`,
    jobTypes: `${CORE_SCHEDULER_BASE_URL}/job-types`,
    create: CORE_SCHEDULER_BASE_URL,
    get: (id: string) => `${CORE_SCHEDULER_BASE_URL}/${id}`,
    delete: (id: string) => `${CORE_SCHEDULER_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_SCHEDULER_BASE_URL}/${id}`,
    run: (id: string) => `${CORE_SCHEDULER_BASE_URL}/run/${id}`,
    resume: (id: string) => `${CORE_SCHEDULER_BASE_URL}/resume/${id}`,
    pause: (id: string) => `${CORE_SCHEDULER_BASE_URL}/pause/${id}`,
};

export const CORE_TASK_QUEUE_BASE_URL = `${CORE_PREFIX}/tasks`;
export const coreTaskUrls = {
    filter: `${CORE_TASK_QUEUE_BASE_URL}/filter`,
    batch: `${CORE_TASK_QUEUE_BASE_URL}/batch`,
    create: CORE_TASK_QUEUE_BASE_URL,
    get: (id: string) => `${CORE_TASK_QUEUE_BASE_URL}/${id}`,
    delete: (id: string) => `${CORE_TASK_QUEUE_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_TASK_QUEUE_BASE_URL}/${id}`,
    reRun: (id: string) => `${CORE_TASK_QUEUE_BASE_URL}/${id}/re-run`,
};

export const CORE_PREFERENCES_BASE_URL = `${CORE_PREFIX}/preferences`;
export const corePreferencesUrl = {
    filter: `${CORE_PREFERENCES_BASE_URL}/filter`,
    bulkSave: `${CORE_PREFERENCES_BASE_URL}/bulk`,
    create: CORE_PREFERENCES_BASE_URL,
    get: (id: string) => `${CORE_PREFERENCES_BASE_URL}/${id}`,
    delete: (id: string) => `${CORE_PREFERENCES_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_PREFERENCES_BASE_URL}/${id}`,
};

export const CORE_ATTACHMENT_BASE_URL = `${CORE_PREFIX}/attachments`;
export const coreAttachmentUrls = {
    filter: `${CORE_ATTACHMENT_BASE_URL}/filter`,
    upload: `${CORE_ATTACHMENT_BASE_URL}/upload`,
    create: CORE_ATTACHMENT_BASE_URL,
    get: (id: string) => `${CORE_ATTACHMENT_BASE_URL}/${id}`,
    download: (id: string) => `${CORE_ATTACHMENT_BASE_URL}/${id}/download`,
    delete: (id: string) => `${CORE_ATTACHMENT_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_ATTACHMENT_BASE_URL}/${id}`,
};

export const CORE_CONTACT_BASE_URL = `${CORE_PREFIX}/contacts`;
export const coreContactUrls = {
    contactTypes: `${CORE_CONTACT_BASE_URL}/types`,
    filter: `${CORE_CONTACT_BASE_URL}/filter`,
    create: CORE_CONTACT_BASE_URL,
    get: (id: string) => `${CORE_CONTACT_BASE_URL}/${id}`,
    delete: (id: string) => `${CORE_CONTACT_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_CONTACT_BASE_URL}/${id}`,
};

export const CORE_APP_ROLE_LIST_URL = `${CORE_PREFIX}/app-roles`;

export const CORE_ROLE_BASE_URL = `${CORE_PREFIX}/roles`;
export const coreRoleUrls = {
    filter: `${CORE_ROLE_BASE_URL}/filter`,
    create: CORE_ROLE_BASE_URL,
    get: (id: string) => `${CORE_ROLE_BASE_URL}/${id}`,
    delete: (id: string) => `${CORE_ROLE_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_ROLE_BASE_URL}/${id}`,
};

export const CORE_USER_ROLE_BASE_URL = `${CORE_PREFIX}/user-roles`;
export const coreUserRoleUrls = {
    filter: `${CORE_USER_ROLE_BASE_URL}/filter`,
    create: CORE_USER_ROLE_BASE_URL,
    get: (id: string) => `${CORE_USER_ROLE_BASE_URL}/${id}`,
    delete: (id: string) => `${CORE_USER_ROLE_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_USER_ROLE_BASE_URL}/${id}`,
};

export const CORE_COMPANY_BASE_URL = `${CORE_PREFIX}/companies`;
export const coreCompanyUrls = {
    filter: `${CORE_COMPANY_BASE_URL}/filter`,
    create: CORE_COMPANY_BASE_URL,
    get: (id: string) => `${CORE_COMPANY_BASE_URL}/${id}`,
    delete: (id: string) => `${CORE_COMPANY_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_COMPANY_BASE_URL}/${id}`,
    updateAresAdis: (id: string) => `/api/tax/ares/update-company/${id}`,
    validateOnCreate: `${CORE_COMPANY_BASE_URL}/validate-on-create`,
    validateOnUpdate: (id: string) => `${CORE_COMPANY_BASE_URL}/${id}/validate-on-update`,
};

export const CORE_PERSON_BASE_URL = `${CORE_PREFIX}/persons`;
export const corePersonUrls = {
    filter: `${CORE_PERSON_BASE_URL}/filter`,
    create: CORE_PERSON_BASE_URL,
    get: (id: string) => `${CORE_PERSON_BASE_URL}/${id}`,
    delete: (id: string) => `${CORE_PERSON_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_PERSON_BASE_URL}/${id}`,
};

export const CORE_ADDRESS_BASE_URL = `${CORE_PREFIX}/addresses`;
export const coreAddressUrls = {
    filter: `${CORE_ADDRESS_BASE_URL}/filter`,
    create: CORE_ADDRESS_BASE_URL,
    get: (id: string) => `${CORE_ADDRESS_BASE_URL}/${id}`,
    delete: (id: string) => `${CORE_ADDRESS_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_ADDRESS_BASE_URL}/${id}`,
};

export const CORE_STATE_BASE_URL = `${CORE_PREFIX}/states`;
export const coreStateUrls = {
    filter: `${CORE_STATE_BASE_URL}/filter`,
    create: CORE_STATE_BASE_URL,
    get: (id: string) => `${CORE_STATE_BASE_URL}/${id}`,
    delete: (id: string) => `${CORE_STATE_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_STATE_BASE_URL}/${id}`,
};

export const CORE_FRONTEND_NOTIFICATION_BASE_URL = `${CORE_PREFIX}/notifications`;
export const coreFrontendNotificationUrls = {
    filter: `${CORE_FRONTEND_NOTIFICATION_BASE_URL}/filter`,
    bulk: `${CORE_FRONTEND_NOTIFICATION_BASE_URL}/bulk`,
    create: CORE_FRONTEND_NOTIFICATION_BASE_URL,
    delete: (id: string) => `${CORE_FRONTEND_NOTIFICATION_BASE_URL}/${id}`,
    update: (id: string) => `${CORE_FRONTEND_NOTIFICATION_BASE_URL}/${id}`,
};

export const CORE_CURRENCY_BASE_URL = `${CORE_PREFIX}/currencies`;
export const taxCurrencyUrls = {
    filter: `${CORE_CURRENCY_BASE_URL}/filter`,
};

/* --- TAX --- */
export const TAX_LICENCE_BASE_URL = `${TAX_PREFIX}/licences`;
export const taxLicenceUrls = {
    filter: `${TAX_LICENCE_BASE_URL}/filter`,
    validOffers: `${TAX_LICENCE_BASE_URL}/valid-offers`,
    createOrder: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/order`,
    topUpCredit: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/top-up-credit`,
    requestPayment: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/payment-request`,
    filterTransactions: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/payment-transaction-filter`,
    filterOrders: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/payment-order-filter`,
    create: TAX_LICENCE_BASE_URL,
    get: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}`,
    delete: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}`,
    update: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}`,
    export: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/export`,
    completeExport: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/export/complete`,
    changeStatus: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/change-status`,
    changeTariff: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/change-tariff`,
    subscriptionPaymentInfo: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/subscription-payment-info`,
    subscriptionPaymentMethod: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/subscription-payment-method`,
    stripeSetupIntent: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/stripe/setup-intent`,
    stripePaymentIntent: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/stripe/payment-intent`,
    stripePaymentMethod: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/stripe/payment-method`,
    stripePendingPayment: (id: string) => `${TAX_LICENCE_BASE_URL}/${id}/stripe/pending-payment`,
};

export const TAX_SUBSCRIPTION_BASE_URL = `${TAX_PREFIX}/subscriptions`;
export const taxSubscriptionUrls = {
    statusCounts: `${TAX_SUBSCRIPTION_BASE_URL}/status-counts`,
    licenceFilter: `${TAX_SUBSCRIPTION_BASE_URL}/licences/filter`,
    licenceExport: `${TAX_SUBSCRIPTION_BASE_URL}/licences/export`,
    invoiceFilter: `${TAX_SUBSCRIPTION_BASE_URL}/invoices/filter`,
    invoiceExport: `${TAX_SUBSCRIPTION_BASE_URL}/invoices/export`,
};
const TAX_DOCUMENT_BASE = `${TAX_PREFIX}/documents`;
const DOCUMENT_ARCHIVE_EXPORT_BASE = `${TAX_DOCUMENT_BASE}/export`;
export const documentUrls = {
    filter: `${TAX_DOCUMENT_BASE}/filter`,
    batch: `${TAX_DOCUMENT_BASE}/batch`,
    createByAttachments: `${TAX_DOCUMENT_BASE}/create_by_attachments`,
    delete: (id: string) => `${TAX_DOCUMENT_BASE}/${id}`,
    update: (id: string) => `${TAX_DOCUMENT_BASE}/${id}`,
    validateOnConfirm: (id: string) => `${TAX_DOCUMENT_BASE}/${id}/validate-document-before-confirm`,
    validateOnSave: (id: string) => `${TAX_DOCUMENT_BASE}/${id}/validate-document-before-save`,
    validateOnFinishCorrection: (id: string) => `${TAX_DOCUMENT_BASE}/${id}/validate-document-before-correction`,
    saveExtracted: (id: string) => `${TAX_DOCUMENT_BASE}/${id}/save-extracted-document`,
    confirmExtracted: (id: string) => `${TAX_DOCUMENT_BASE}/${id}/confirm-extracted-document`,
    get: (id: string) => `${TAX_DOCUMENT_BASE}/${id}`,
    integrationRequest: (id: string) => `${TAX_DOCUMENT_BASE}/${id}/integration-request`,
    downloadIsdoc: (id: string) => `${TAX_DOCUMENT_BASE}/${id}/download-isdoc`,
    changeStatus: (id: string) => `${TAX_PREFIX}/documents/${id}/change-status`,
    approve: (id: string) => `${TAX_PREFIX}/documents/${id}/approve`,
    disapprove: (id: string) => `${TAX_PREFIX}/documents/${id}/disapprove`,
    export: {
        export: DOCUMENT_ARCHIVE_EXPORT_BASE,
        count: `${DOCUMENT_ARCHIVE_EXPORT_BASE}/count`,
        download: (taskId: string) => `${DOCUMENT_ARCHIVE_EXPORT_BASE}/${taskId}/download`,
        delete: (taskId: string) => `${DOCUMENT_ARCHIVE_EXPORT_BASE}/${taskId}`,
    },
    getPaymentMeans: `${TAX_DOCUMENT_BASE}/payment-means`,
    classifications: `${TAX_DOCUMENT_BASE}/classifications`,
    roundItems: (id: string) => `${TAX_DOCUMENT_BASE}/${id}/round-items`,
    reRunRecogniserTask: (id: string) => `${TAX_DOCUMENT_BASE}/${id}/re-run-recogniser-task`,
};

export const TAX_ACCOUNTANT_BASE_URL = `${TAX_PREFIX}/accountants`;
export const taxAccountantUrls = {
    filter: `${TAX_ACCOUNTANT_BASE_URL}/filter`,
    createByWizard: `${TAX_ACCOUNTANT_BASE_URL}/create-by-wizard`,
    create: TAX_ACCOUNTANT_BASE_URL,
    get: (id: string) => `${TAX_ACCOUNTANT_BASE_URL}/${id}`,
    delete: (id: string) => `${TAX_ACCOUNTANT_BASE_URL}/${id}`,
    update: (id: string) => `${TAX_ACCOUNTANT_BASE_URL}/${id}`,
};
export const taxAccountantOnboardingUrls = {
    submit: `${TAX_ACCOUNTANT_BASE_URL}/onboarding`,
    filter: `${TAX_ACCOUNTANT_BASE_URL}/onboarding/filter`,
};
export const TAX_ACCOUNTANT_SETTINGS_BASE_URL =`${TAX_PREFIX}/accountant-settings`;
export const taxAccountantSettingsUrls = {
    filter: `${TAX_ACCOUNTANT_SETTINGS_BASE_URL}/filter`,
    synchronize: `${TAX_ACCOUNTANT_SETTINGS_BASE_URL}/synchronize`,
    create: TAX_ACCOUNTANT_SETTINGS_BASE_URL,
    update: (id: string) => `${TAX_ACCOUNTANT_SETTINGS_BASE_URL}/${id}`,
};

export const TAX_CLIENT_BASE_URL = `${TAX_PREFIX}/clients`;
export const taxClientUrls = {
    filter: `${TAX_CLIENT_BASE_URL}/filter`,
    createByWizard: `${TAX_CLIENT_BASE_URL}/create-by-wizard`,
    create: TAX_CLIENT_BASE_URL,
    get: (id: string) => `${TAX_CLIENT_BASE_URL}/${id}`,
    delete: (id: string) => `${TAX_CLIENT_BASE_URL}/${id}`,
    update: (id: string) => `${TAX_CLIENT_BASE_URL}/${id}`,
    correctionToggle: (id: string) => `${TAX_CLIENT_BASE_URL}/${id}/correction/toggle`,
    correctionCalculate: (id: string) => `${TAX_CLIENT_BASE_URL}/${id}/correction/calculate`,
};

export const TAX_DOCUMENT_ATTACHMENT_BASE_URL = `${TAX_PREFIX}/document-attachments`;
export const taxDocumentAttachmentUrls = {
    filter: `${TAX_DOCUMENT_ATTACHMENT_BASE_URL}/filter`,
    create: TAX_DOCUMENT_ATTACHMENT_BASE_URL,
    get: (id: string) => `${TAX_DOCUMENT_ATTACHMENT_BASE_URL}/${id}`,
    delete: (id: string) => `${TAX_DOCUMENT_ATTACHMENT_BASE_URL}/${id}`,
    update: (id: string) => `${TAX_DOCUMENT_ATTACHMENT_BASE_URL}/${id}`,
};

export const TAX_VAT_RATE_BASE_URL = `${TAX_PREFIX}/vat-rates`;
export const taxVatRateUrls = {
    filter: `${TAX_VAT_RATE_BASE_URL}/filter`,
    create: TAX_VAT_RATE_BASE_URL,
    get: (id: string) => `${TAX_VAT_RATE_BASE_URL}/${id}`,
    delete: (id: string) => `${TAX_VAT_RATE_BASE_URL}/${id}`,
    update: (id: string) => `${TAX_VAT_RATE_BASE_URL}/${id}`,
};

export const TAX_ARES_BASE_URL = `${TAX_PREFIX}/ares`;
export const taxAresUrls = {
    createByIco: (ico: string) => `${TAX_ARES_BASE_URL}/create-company-by-ico/${ico}`,
    createByDic: (dic: string) => `${TAX_ARES_BASE_URL}/create-company-by-dic/${dic}`,
    updateCompany: (companyId: string) => `${TAX_ARES_BASE_URL}/update-company/${companyId}`,
};

export const TAX_PRE_ACCOUNTING_BASE_URL = `${TAX_PREFIX}/pre-accountings`;
export const preAccountingUrls = {
    get: (id: string) => `${TAX_PRE_ACCOUNTING_BASE_URL}/${id}`,
    toggleDefault: (id: string) => `${TAX_PRE_ACCOUNTING_BASE_URL}/${id}/toggle-default`,
    filter: `${TAX_PRE_ACCOUNTING_BASE_URL}/filter`,
    create: TAX_PRE_ACCOUNTING_BASE_URL,
    update: (id: string) => `${TAX_PRE_ACCOUNTING_BASE_URL}/${id}`,
    updateClients: (id: string) => `${TAX_PRE_ACCOUNTING_BASE_URL}/${id}/clients`,
    delete: (id: string) => `${TAX_PRE_ACCOUNTING_BASE_URL}/${id}`,
    copyPreAccountings: `${TAX_PRE_ACCOUNTING_BASE_URL}/copy-accountant-preAccounting`,
    copyClientPreAccountings: `${TAX_PRE_ACCOUNTING_BASE_URL}/copy-client-preAccounting`,
};

export const TAX_CENTRE_BASE_URL = `${TAX_PREFIX}/centres`;
export const taxCentresUrls = {
    create: TAX_CENTRE_BASE_URL,
    get: (id: string) => `${TAX_CENTRE_BASE_URL}/${id}`,
    update: (id: string) => `${TAX_CENTRE_BASE_URL}/${id}`,
    filter: `${TAX_CENTRE_BASE_URL}/filter`,
    delete: (id: string) => `${TAX_CENTRE_BASE_URL}/${id}`,
};
export const TAX_INTEGRATIONS_BASE_URL = `${TAX_PREFIX}/integrations`;
export const taxIntegrationsUrls = {
    get: (id: string) => `${TAX_INTEGRATIONS_BASE_URL}/${id}`,
    create: TAX_INTEGRATIONS_BASE_URL,
    update: (id: string) => `${TAX_INTEGRATIONS_BASE_URL}/${id}`,
    changeIntegrationPassword: (id: string) => `${TAX_INTEGRATIONS_BASE_URL}/${id}/password`,
    importIntegrationData: (id: string) => `${TAX_INTEGRATIONS_BASE_URL}/${id}/import`,
    agendas: `${TAX_INTEGRATIONS_BASE_URL}/agendas`,
};
export const TAX_PRE_ACCOUNTING_CLIENT_BASE_URL = `${TAX_PREFIX}/pre-accounting-clients`;
export const preAccountingClientUrls = {
    get: (id: string) => `${TAX_PRE_ACCOUNTING_CLIENT_BASE_URL}/${id}`,
    filter: `${TAX_PRE_ACCOUNTING_CLIENT_BASE_URL}/filter`,
    create: TAX_PRE_ACCOUNTING_CLIENT_BASE_URL,
    delete: (id: string) => `${TAX_PRE_ACCOUNTING_CLIENT_BASE_URL}/${id}`,
};

export const CORE_REVISION_BASE_URL = `${CORE_PREFIX}/revisions`;
export const coreRevisionsUrls = {
    filter: `${CORE_REVISION_BASE_URL}/filter`,
    entities: `${CORE_REVISION_BASE_URL}/entities`,
    detail: `${CORE_REVISION_BASE_URL}/detail`,
    relatedRevision: `${CORE_REVISION_BASE_URL}/{id}/related-revisions`,
    compare: `${CORE_REVISION_BASE_URL}/compare-revisions`,
};

export const TAX_DOCUMENT_ITEMS_BASE_URL = `${TAX_PREFIX}/document-items`;
export const documentItemsUrls = {
    get: (id: string) => `${TAX_DOCUMENT_ITEMS_BASE_URL}/${id}`,
    filter: `${TAX_DOCUMENT_ITEMS_BASE_URL}/filter`,
    create: TAX_DOCUMENT_ITEMS_BASE_URL,
    splitByBase: (id: string) => `${TAX_DOCUMENT_ITEMS_BASE_URL}/${id}/split-by-base`,
    delete: (id: string) => `${TAX_DOCUMENT_ITEMS_BASE_URL}/${id}`,
    update: (id: string) => `${TAX_DOCUMENT_ITEMS_BASE_URL}/${id}`,
};

export const PAYMENT_REQUEST_BASE_URL = `${CORE_PREFIX}/payment-requests`;
export const paymentRequestUrl = {
    filter: `${PAYMENT_REQUEST_BASE_URL}/filter`,
    gateways: `${PAYMENT_REQUEST_BASE_URL}/gateways`,
    get: (id: string) => `${PAYMENT_REQUEST_BASE_URL}/${id}`,
    markPaid: (id: string) => `${PAYMENT_REQUEST_BASE_URL}/${id}/paid`,
    markCanceled: (id: string) => `${PAYMENT_REQUEST_BASE_URL}/${id}/canceled`,
};
export const PAYMENT_TRANSACTION_BASE_URL = `${CORE_PREFIX}/payment-transactions`;
export const paymentTransactionUrls = {
    filter: `${PAYMENT_TRANSACTION_BASE_URL}/filter`,
};

export const TAX_REGISTRATIONS_BASE_URL = `${TAX_PREFIX}/registrations`;
export const taxRegistrationsUrls = {
    create: `${TAX_REGISTRATIONS_BASE_URL}`,
    verify: `${TAX_REGISTRATIONS_BASE_URL}/verify`,
    complete: `${TAX_REGISTRATIONS_BASE_URL}/complete`,
};

export const TAX_SELF_REGISTRATIONS_BASE_URL = `${TAX_PREFIX}/self-registrations`;
export const taxSelfRegistrationsUrls = {
    filter: `${TAX_SELF_REGISTRATIONS_BASE_URL}/filter`,
    get: (id: string) => `${TAX_SELF_REGISTRATIONS_BASE_URL}/${id}`,
    accept: (id: string) => `${TAX_SELF_REGISTRATIONS_BASE_URL}/${id}/accept`,
    reject: (id: string) => `${TAX_SELF_REGISTRATIONS_BASE_URL}/${id}/reject`,
};

export const TAX_ABRA_DOCUMENT_TYPE_BASE_URL = `${TAX_PREFIX}/abra-document-types`;
export const taxAbraDocumentTypeUrls = {
    filter: `${TAX_ABRA_DOCUMENT_TYPE_BASE_URL}/filter`,
    get: (id: string) => `${TAX_ABRA_DOCUMENT_TYPE_BASE_URL}/${id}`,
};

export const RECOGNISER_INFO_BASE_URL = `${TAX_PREFIX}/recogniser`;
export const recogniserUrls = {
    info: `${RECOGNISER_INFO_BASE_URL}/info`,
};

export const TAX_CONTRACT_BASE_URL = `${TAX_PREFIX}/contracts`;
export const taxContractUrls = {
    filter: `${TAX_CONTRACT_BASE_URL}/filter`,
    createByWizard: `${TAX_CONTRACT_BASE_URL}/create-by-wizard`,
    create: TAX_CONTRACT_BASE_URL,
    get: (id: string) => `${TAX_CONTRACT_BASE_URL}/${id}`,
    delete: (id: string) => `${TAX_CONTRACT_BASE_URL}/${id}`,
    update: (id: string) => `${TAX_CONTRACT_BASE_URL}/${id}`,
};

export const TAX_ACTIVITY_BASE_URL = `${TAX_PREFIX}/activities`;
export const taxActivitiesUrls = {
    get: (id: string) => `${TAX_ACTIVITY_BASE_URL}/${id}`,
    filter: `${TAX_ACTIVITY_BASE_URL}/filter`,
    create: TAX_ACTIVITY_BASE_URL,
    update: (id: string) => `${TAX_ACTIVITY_BASE_URL}/${id}`,
    delete: (id: string) => `${TAX_ACTIVITY_BASE_URL}/${id}`,
};

export const TAX_OFFICER_BASE_URL = `${TAX_PREFIX}/officers`;
export const taxOfficerUrls = {
    filter: `${TAX_OFFICER_BASE_URL}/filter`,
    createByWizard: `${TAX_OFFICER_BASE_URL}/create-by-wizard`,
    create: TAX_OFFICER_BASE_URL,
    get: (id: string) => `${TAX_OFFICER_BASE_URL}/${id}`,
    delete: (id: string) => `${TAX_OFFICER_BASE_URL}/${id}`,
    update: (id: string) => `${TAX_OFFICER_BASE_URL}/${id}`,
};

export const TAX_APPROVER_BASE_URL = `${TAX_PREFIX}/approvers`;
export const taxApproverUrls = {
    filter: `${TAX_APPROVER_BASE_URL}/filter`,
    createByWizard: `${TAX_APPROVER_BASE_URL}/create-by-wizard`,
    create: TAX_APPROVER_BASE_URL,
    get: (id: string) => `${TAX_APPROVER_BASE_URL}/${id}`,
    delete: (id: string) => `${TAX_APPROVER_BASE_URL}/${id}`,
    update: (id: string) => `${TAX_APPROVER_BASE_URL}/${id}`,
};

export const TAX_CENTRE_SHARES_BASE_URL = `${TAX_PREFIX}/document-centre-shares`;
export const taxCentreSharesUrls = {
    create: TAX_CENTRE_SHARES_BASE_URL,
    get: (id: string) => `${TAX_CENTRE_SHARES_BASE_URL}/${id}`,
    update: (id: string) => `${TAX_CENTRE_SHARES_BASE_URL}/${id}`,
    filter: `${TAX_CENTRE_SHARES_BASE_URL}/filter`,
    delete: (id: string) => `${TAX_CENTRE_SHARES_BASE_URL}/${id}`,
};